import { useUIAppState } from "../../context/ui-appState";
import { useExcalidrawActionManager } from "../App";

/** Quick paper switcher for the canvas footer (render inside `<Footer>`). */
export const CanvasPaperSwitcher = () => {
  const appState = useUIAppState();
  const actionManager = useExcalidrawActionManager();

  if (appState.viewModeEnabled) {
    return null;
  }

  return (
    <div className="CanvasPaperSwitcher">
      {actionManager.renderAction("changeCanvasPaper", { compact: true })}
    </div>
  );
};
